import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, graphql } from 'gatsby'

import Bio from 'components/bio'
import Layout from 'components/layout'
import SEO from 'components/seo'
import { rhythm } from 'utils/typography'
import Button from 'components/button'

const Legal = ({ data, location }) => {
  const { t } = useTranslation('legal')
  const legalTitle = data.site.siteMetadata.legalTitle
  const posts = data.allMdx.edges

  return (
    <Layout location={location} title={legalTitle}>
      <SEO title={t('title')} />
      <Bio />
      <div style={{ margin: '20px 0 40px' }}>
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug
          return (
            <div key={node.fields.slug}>
              <h3
                style={{
                  marginBottom: rhythm(1 / 4),
                }}
              >
                <Link
                  style={{ boxShadow: `none` }}
                  to={`/legal${node.fields.slug}`}
                >
                  {title}
                </Link>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: node.frontmatter.description || node.excerpt,
                }}
              />
            </div>
          )
        })}
      </div>
      <Link to="/">
        <Button marginTop="85px">{t('goHome')}</Button>
      </Link>
    </Layout>
  )
}

export default Legal

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        legalTitle
      }
    }
    allMdx(
      filter: { fields: { sourceName: { eq: "legal" } } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
        }
      }
    }
  }
`
